import { NavigationGuardNext, Route } from 'vue-router';

export const validateIntegerParam = (paramName: string) => (
  to: Route,
  from: Route,
  next: NavigationGuardNext,
) => {
  const param = Number(to.params[paramName]);

  if (Number.isInteger(param) && param !== 0) {
    next();
  } else {
    next(from.fullPath);
  }
};
